import { shouldPolyfill } from '@formatjs/intl-pluralrules/should-polyfill';

export async function loadIntlPluralRules(locale) {
  const unsupportedLocale = shouldPolyfill(locale);
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import(
    /* webpackChunkName: "polyfill/intl-pluralrules/polyfill-force" */
    '@formatjs/intl-pluralrules/polyfill-force'
  );
  await import(
    /* webpackChunkName: "polyfill/intl-pluralrules/locale-data" */
    `@formatjs/intl-pluralrules/locale-data/${unsupportedLocale}.js`
  );
}
